

export default function ErrorPage(p:{
  message:string
}) {


  return (
    <div role="alert" className={"m-32"}>
      <p>Noget gik galt:</p>
      <pre style={{color: "red"}}>{p.message}</pre>
    </div>
  )

}